import React, { useState, useEffect } from "react";
import { useCallback } from "react/cjs/react.production.min";
import logo from "../assets/images/logo.png";
// import mr3 from "../assets/images/3.png";
import mr3 from "../assets/images/mrcrypto_nft.gif";
import NftsMintedData from "./NftsMintedData";
import TransakComponet from "./transak";
import {useTranslation} from "react-i18next";

const MintSection = ({
  MintNFT,
  showNftComponent,
  nfts,
  minting,
  txn,
  currentSupply,
  price,
  wallet,
  whitelistOn,
  userw,
}) => {
  const [ t ] = useTranslation(['home']);
  const [count, setCount] = useState(1);
  const [mintModality, setMintModality] = useState(false);
  const [tokenId, setTokenId] = useState("");

  const [timer, setTimer] = useState("");

  const handleTokenIdchange = (e) => {
    // si tokenId < 1000 -> mostrar msj de que tokenid must be greater than 1000.
    //coger ese tokenId y ver si ha sido utilizado para mint especial.

    setTokenId(e.target.value);
  };

  // useEffect(() => {
  //   //timerDecrement();
  // }, [timer]);

  useEffect(() => {}, [count]);

  const increment = () => {
    if (count < 20) {
      setCount(count + 1);
    } else {
      setCount(20);
    }
  };

  const decrement = () => {
    count > 1 ? setCount(count - 1) : setCount(1);
  };

  // const timerDecrement = () => {
  //   // Set the date we're counting down to
  //   var countDownField = "Tue, 05 Apr 2022 21:55:00";

  //   var countDownDate = new Date(countDownField).getTime();
  //   // Update the count down every 1 second
  //   var x = setInterval(function () {
  //     // Get today's date and time
  //     var now = new Date().getTime();
  //     // Find the distance between now and the count down date
  //     var distance = countDownDate - now;

  //     // Time calculations for days, hours, minutes and seconds
  //     var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  //     var hours = Math.floor(
  //       (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  //     );
  //     var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  //     var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  //     if (days < 10) {
  //       days = "0" + days;
  //     }
  //     if (hours < 10) {
  //       hours = "0" + hours;
  //     }
  //     if (minutes < 10) {
  //       minutes = "0" + minutes;
  //     }
  //     if (seconds < 10) {
  //       seconds = "0" + seconds;
  //     }

  //     // Display the result in the element with id="demo"
  //     setTimer(days + "D " + hours + "H " + minutes + "M " + seconds + "S ");

  //     // If the count down is finished, write some text
  //     if (distance < 0) {
  //       clearInterval(x);
  //       setTimer = "EXPIRED";
  //     }

  //     console.log(timer);
  //   }, 1000);
  // };

  return (
    <div className="container pt-5 pb-5 " id="NFTsSection">
      <IsWhitelisted whitelistOn={whitelistOn} userw={userw} />
      <div className="row">
        <div className="col-12 col-lg-4 offset-lg-4 pt-5">
          <div className="borderTable text-center px-5 pb-4">
            <img className="logoImg" src={logo} />
            <img className="w-100 pb-3" src={mr3} />

            <h1 className="titleYellow">Mr crypto</h1>
            <p>
              <span>MR. Crypto</span> {t("IsTheUltimateNFTs")} <br />
              {t("OfficialOf")} <span>Racks Mafia</span>. 10000 {t("units")} <br />
              {t("AvailableBy")}
              {/*{price} matic.*/}
            </p>
            <div>
              <p
                className="text-center"
                onClick={() => setMintModality(!mintModality)}
              ></p>
            </div>

            {/*<div className="count__container">*/}
            {/*  <button className="count__btn" onClick={() => decrement()}>*/}
            {/*    -*/}
            {/*  </button>*/}
            {/*  <span>{count}</span>*/}
            {/*  <button className="count__btn" onClick={() => increment()}>*/}
            {/*    +*/}
            {/*  </button>*/}
            {/*</div>*/}

            <div className="row px-0 mx-0">
              {/*{mintModality ? (*/}
              {/*  <p className="pb-4">Total price {price} MATIC</p>*/}
              {/*) : (*/}
              {/*  <p className="pb-4">Total price {price * count} MATIC</p>*/}
              {/*)}*/}
              <div className="col-12  ">
                <div
                  className="btn-native "
                  // onClick={
                  //   mintModality
                  //     ? console.log("reserved mint")
                  //     : () => MintNFT(count)
                  // }
                >
                  {minting ? (
                    <span className="btn-native-child ">MINTING...</span>
                  ) : (
                    <a target="_blank"
                       href="https://opensea.io/collection/mrcrypto-by-racksmafia" className="btn-native-child ">{t('Purchase')}</a>
                  )}
                </div>
              </div>
              <div className="col-12">
                <label className="colordisabled pt-5">
                  {currentSupply !== 0 && (
                    <span className="nav-link">
                      {10000 - currentSupply} {t('from')}  10000 {t('Available')}
                    </span>
                  )}
                  {/*<span>{t("ComingSoon")}</span>*/}
                </label>
                <br />
                {/*<a*/}
                {/*  onClick={() => TransakComponet()}*/}
                {/*  className="colordisabled"*/}
                {/*  target="_blank"*/}
                {/*>*/}
                {/*  ¿Necesitas comprar MATIC?*/}
                {/*</a>*/}
                <a
                  href={`https://ramp.network/buy/?defaultAsset=MATIC&userAddress=${wallet}`}
                  target="_blank"
                  className="colordisabled"
                  target="_blank"
                >
                  {t("Youneedtobuy")}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      {txn && (
        <div style={{ paddingTop: "20px" }} className="text-center">
          {" "}
          <span>
            {t("CompletedTransaction")}{" "}
            <a className="txn-link" target="_blank" href={txn}>
               {t("ToSeeIn")} polygonscan
            </a>
          </span>{" "}
        </div>
      )}
      {showNftComponent && (
        <div>
          <h1 className="text-center mt-5 mb-5"> {t("NFTshaveBeenMinted")} </h1>
          <NftsMintedData nfts={nfts} wallet={wallet} />
        </div>
      )}
    </div>
  );
};

export default MintSection;

const IsWhitelisted = ({ whitelistOn, userw }) => {
  // funcion que llame al contrato y diga si el user esta whitelisted
  const [ t ] = useTranslation(['home']);
  return (
    <>
      {whitelistOn && (
        <div className="isWhitelistedContainer">
          {userw ? (
            <p className="userInWhitelist">
              {t("CongratulationsTheWhitelist")}
            </p>
          ) : (
            <p className="userNotInWhitelist">
              {t("SorryYouNotWhitelist")}
            </p>
          )}
        </div>
      )}
    </>
  );
};
